module.exports = __webpack_public_path__ + "static/woman-b-8d3abc64b4af86e02d20600b641fbbc7.jpg";